module.exports = __webpack_public_path__ + "static/assets/6ca41056dd699590df9d545730b0a146.gif";